/**
 * 로그인·로그아웃 흐름이 옮겨 가는 앱 라우트. import 없는 리프로 둔다 — 테스트가 factory 로 mock 하는 모듈(밀려남
 * 처리기 등)에 두면, 그 mock 아래에서 다른 소비처가 값을 읽지 못한다.
 */

/** 로그인 화면(`src/pages/login.tsx`). */
export const LOGIN_ROUTE = "/login";

/** 하이보드 SSO 콜백 화면(`src/pages/auth/callback.tsx`). */
export const SSO_CALLBACK_ROUTE = "/auth/callback";

/**
 * 로그아웃의 종착지. 명시적 로그아웃(`useAuth.signOut`), 로그아웃을 전해 받은 탭(`useLoginSessionWatcher`), 로그아웃
 * 뒤에 받은 밀려남 신호(`handleLoginSuperseded`)가 이곳으로 옮긴다(스펙 `exclusive-login`). SSO 확인창 취소 뒤의
 * 이동(`HighboardCallbackPage`)은 스펙이 따로 정한 결정이라 이 값을 읽지 않는다.
 */
export const SIGNED_OUT_ROUTE = "/";
